var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralCertificationCctv = function SvgGeneralCertificationCctv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF540F",
    fillRule: "evenodd",
    d: "M8.688 8.384v1.21h2.882v.804H8.688a.805.805 0 0 1-.805-.805V8.521a1.3 1.3 0 0 1-.882-.55l-.914.606a.75.75 0 0 1-1.039-.21L3.533 6.086a.75.75 0 0 1 .21-1.04l4.4-2.921a.75.75 0 0 1 1.039.21l1.515 2.281a.75.75 0 0 1-.21 1.04l-1.303.865c.386.602.22 1.404-.377 1.8a1 1 0 0 1-.08.044q-.02.009-.039.02m-5.344 2.014L1 6.868l2-.82 1.875 2.825z",
    clipRule: "evenodd"
  })));
};
export default SvgGeneralCertificationCctv;